import { AnyAction } from 'redux';
import { CLOSE_SNACKBAR, ENQUEUE_SNACKBAR, NotifyNotification, REMOVE_SNACKBAR } from './actions';

interface NotificationsState {
    notifications: NotifyNotification[];
}
const defaultState: NotificationsState = {
    notifications: [],
};

function notificationReducer(state: NotificationsState = defaultState, action: AnyAction) {
    switch (action.type) {
        case ENQUEUE_SNACKBAR:
            return {
                ...state,
                notifications: [
                    ...state.notifications,
                    {
                        key: action.key,
                        ...action.notification,
                    },
                ],
            };

        case CLOSE_SNACKBAR:
            return {
                ...state,
                notifications: state.notifications.map(notification =>
                    action.dismissAll || notification.key === action.key
                        ? { ...notification, dismissed: true }
                        : { ...notification }
                ),
            };

        case REMOVE_SNACKBAR:
            return {
                ...state,
                notifications: state.notifications.filter(notification => notification.key !== action.key),
            };

        default:
            return state;
    }
}

export default notificationReducer;
